import React from 'react'
import { Chip } from '../../components/ui/Chip'
import { s } from './listings-shared'

const LISTING_VARIANT: Record<string, 'gray' | 'green' | 'red'> = {
  draft: 'gray',
  published: 'green',
  closed: 'red',
}

export function ListingStatusChip({ status }: { status: string }) {
  return <Chip variant={LISTING_VARIANT[status] ?? 'gray'}>{s.status[status] ?? status}</Chip>
}

export function PageHeader({ title, subtitle, action }: { title: string; subtitle?: string; action?: React.ReactNode }) {
  return (
    <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 16, flexWrap: 'wrap', paddingBottom: 24 }}>
      <div style={{ minWidth: 0 }}>
        <div style={{ fontSize: 20, fontWeight: 700, color: '#111827', marginBottom: 3, overflowWrap: 'anywhere' }}>{title}</div>
        {subtitle && <div style={{ fontSize: 14, color: '#6b7280' }}>{subtitle}</div>}
      </div>
      {action}
    </div>
  )
}

export function ErrorLine({ children }: { children: React.ReactNode }) {
  return (
    <div role="alert" style={{ fontSize: 13, color: '#dc2626', marginTop: 8 }}>
      {children}
    </div>
  )
}
